/**
 * Whether Datadog RUM {@link beforeSend} should drop a failed `fetch` resource event.
 *
 * {@link useApiFetch} registers the request URL in {@link activeUseApiFetchRequests} for the
 * duration of ofetch retries. Intermediate 4xx/5xx attempts stay in that set and are suppressed
 * so only the final failure (after the URL is removed) is eligible to reach Datadog.
 */
export function shouldSuppressDatadogApiFetchResource(
    resourceUrl: string,
    statusCode: number | undefined,
    activeRequests: ReadonlySet<string>
): boolean {
    return typeof statusCode === 'number' && statusCode >= 400 && activeRequests.has(resourceUrl)
}
